export const OPTION_LABEL_ACCESSORS = ['ans_opt', 'option_value'];

export const COMPARE_BY_ACCESSOR = 'compare_by_breakout';
